import { render } from "./DashboardWinnings.vue?vue&type=template&id=2d5c97c5"
import script from "./DashboardWinnings.vue?vue&type=script&lang=js"
export * from "./DashboardWinnings.vue?vue&type=script&lang=js"
script.render = render

export default script